export default class CustomPopup {
  constructor() {
    this.customPopup = document.querySelector('.custom-popup');
    this.customPopupContent = document.querySelector('.custom-popup .view-content');
    this.customPopupBlockInner = document.querySelector('.custom-popup .block-inner');
    this.customPopupLinks = document.querySelectorAll('.custom-popup .node-content a');
    this.closeBtn = document.createElement('div');
    this.expirationDays = 1;
    this.cookieName = 'cp_custompopup';

    this.setup();
  }

  setup() {
    this.setupCloseButton();
    this.addBlankTargetToLinks();
    this.showPopupIfNecessary();
  }

  setupCloseButton() {
    this.closeBtn.classList.add('close_btn');
    this.closeBtn.textContent = 'Dismiss';

    this.closeBtn.addEventListener('click', () => {
      this.hidePopup();
    }, { once: true });

    this.customPopupBlockInner.insertAdjacentElement('afterbegin', this.closeBtn);
  }

  addBlankTargetToLinks() {
    if (this.customPopupLinks) {
      this.customPopupLinks.forEach((link) => {
        link.setAttribute('target', '_blank');
      });
    }
  }

  showPopupIfNecessary() {
    if (this.customPopupContent && !this.hasCookie()) {
      this.showPopup();
      // this.setCookie();
      this.clickHidePopup();
    }
  }

  showPopup() {
    this.customPopup.classList.add('show');
  }

  hidePopup() {
    this.customPopup.classList.remove('show');
  }

  clickHidePopup() {
    this.customPopup.addEventListener('click', () => { this.hidePopup(); }, { once: true });
  }

  setCookie() {
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + (this.expirationDays * 24 * 60 * 60 * 1000));
    document.cookie = `${this.cookieName}=1;expires=${expirationDate.toUTCString()};`;
  }

  hasCookie() {
    return document.cookie.includes(this.cookieName);
  }
}
